import { useEffect } from 'react';

interface MetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

export const useMetaTags = ({ title, description, image, url, type = 'website' }: MetaTagsProps) => {
  useEffect(() => {
    // Función para actualizar o crear meta tags
    const updateMetaTag = (property: string, content: string, isProperty = true) => {
      const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
      let element = document.querySelector(selector) as HTMLMetaElement;

      if (!element) {
        element = document.createElement('meta');
        if (isProperty) {
          element.setAttribute('property', property);
        } else {
          element.setAttribute('name', property);
        }
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    // Actualizar title
    if (title) {
      document.title = title;
      updateMetaTag('og:title', title);
      updateMetaTag('twitter:title', title);
    }

    // Actualizar description
    if (description) {
      updateMetaTag('description', description, false);
      updateMetaTag('og:description', description);
      updateMetaTag('twitter:description', description);
    }

    // Actualizar image
    if (image) {
      updateMetaTag('og:image', image);
      updateMetaTag('twitter:image', image);
    }

    // Actualizar URL
    if (url) {
      updateMetaTag('og:url', url);
      updateMetaTag('twitter:url', url);
    }

    // Configurar tipo
    updateMetaTag('og:type', type);
    updateMetaTag('twitter:card', 'summary_large_image');

    // Meta tags adicionales
    updateMetaTag('og:site_name', 'Florentina Garden');
    updateMetaTag('twitter:site', '@florentina');

  }, [title, description, image, url, type]);
};
